import { JSX } from 'react'

import { IconProps } from '../../icon'

const Index: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.4038 35.663H17.0055C16.1236 35.663 15.4088 34.9482 15.4088 34.0662C15.4088 33.1843 16.1236 32.4695 17.0055 32.4695H38.4033C39.2852 32.4695 40 33.1843 40 34.0662C40 34.9482 39.2857 35.663 38.4038 35.663Z'
      fill='black'
    />
    <path
      d='M38.4038 25.6403H17.0055C16.1236 25.6403 15.4088 24.9255 15.4088 24.0436C15.4088 23.1616 16.1236 22.4468 17.0055 22.4468H38.4033C39.2852 22.4468 40 23.1616 40 24.0436C40.0005 24.9255 39.2857 25.6403 38.4038 25.6403Z'
      fill='black'
    />
    <path
      d='M38.4038 15.6176H17.0055C16.1236 15.6176 15.4088 14.9028 15.4088 14.0209C15.4088 13.139 16.1236 12.4242 17.0055 12.4242H38.4033C39.2852 12.4242 40 13.139 40 14.0209C40 14.9028 39.2857 15.6176 38.4038 15.6176Z'
      fill='black'
    />
    <path
      d='M10.1444 16.2888C11.3287 16.2888 12.2888 15.3287 12.2888 14.1444C12.2888 12.9601 11.3287 12 10.1444 12C8.96008 12 8 12.9601 8 14.1444C8 15.3287 8.96008 16.2888 10.1444 16.2888Z'
      fill='black'
    />
    <path
      d='M10.1444 26.188C11.3287 26.188 12.2888 25.2279 12.2888 24.0436C12.2888 22.8593 11.3287 21.8992 10.1444 21.8992C8.96008 21.8992 8 22.8593 8 24.0436C8 25.2279 8.96008 26.188 10.1444 26.188Z'
      fill='black'
    />
    <path
      d='M10.1444 36.0871C11.3287 36.0871 12.2888 35.1271 12.2888 33.9427C12.2888 32.7584 11.3287 31.7983 10.1444 31.7983C8.96008 31.7983 8 32.7584 8 33.9427C8 35.1271 8.96008 36.0871 10.1444 36.0871Z'
      fill='black'
    />
  </svg>
)

export default Index
